import React from 'react'

export default function PreparationStep() {
  const steps = [
    {
      icon: '/img/gijinkoku/Vector_1.svg',
      title:
        'Mengikuti pelatihan bahasa Jepang dan persiapan kerja di YES.co.id',
    },
    {
      icon: '/img/gijinkoku/Vector_2.svg',
      title: 'Mengambil sertifikasi JLPT N3',
    },
    {
      icon: '/img/gijinkoku/Vector_3.svg',
      title: 'Apply kerja di YES Job Portal',
    },
    {
      icon: '/img/gijinkoku/Vector_4.svg',
      title: 'Mengikuti rangkaian proses seleksi dan lolos wawancara',
    },
  ]

  return (
    <section className="bg-gray-50 py-16">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-16 text-center">
          <h2 className="text-2xl font-bold text-gray-700">
            Tahapan Persiapan Kerja di Jepang
          </h2>
        </div>

        <div className="relative flex flex-col items-center justify-center gap-8 md:flex-row lg:items-start">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative z-10 flex w-56 flex-col items-center text-center"
            >
              <div className="mb-4 flex h-32 w-32 items-center justify-center rounded-lg border border-gray-300 bg-white">
                <img src={step.icon} alt="icon" />
              </div>
              <div className="text-xl leading-tight text-gray-700">
                {step.title.includes('YES.co.id') ? (
                  <>
                    <span>
                      Mengikuti pelatihan bahasa Jepang dan persiapan kerja
                      di{' '}
                    </span>
                    <span className="font-bold text-red-600">YES.co.id</span>
                  </>
                ) : step.title.includes('YES Job Portal') ? (
                  <>
                    <span>Apply kerja di </span>
                    <span className="font-bold text-red-600">
                      YES Job Portal
                    </span>
                  </>
                ) : (
                  step.title
                )}
              </div>
            </div>
          ))}

          {/* Garis connecting lines - hanya antara step 2-5 (index 1-4) */}
          {[1, 2, 3].map((lineIndex) => (
            <div
              key={lineIndex}
              className="absolute top-16 z-0 hidden border-t-2 border-dashed border-gray-400 md:block"
              style={{
                left: `${lineIndex * 21}%`,
                width: '20%',
              }}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
